<ion-content>
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button color="light" shape="round" (click)="close()"
                ><ion-icon src="assets/icon/cross.svg"></ion-icon
            ></ion-button>
        </ion-buttons>
    </ion-toolbar>
    <div class="main-container">
        <div class="container">
            <img src="/assets/img/logo-stream.png" />
            <h2>{{ 'COMPONENTS.RATING_MODAL.TITLE' | translate }}</h2>
            <h3>
                {{ 'COMPONENTS.RATING_MODAL.STORE_MESSAGE' | translate }}
                {{
                    ' ' +
                        ((deviceType === 'android'
                            ? 'COMPONENTS.RATING_MODAL.ANDROID_STORE'
                            : 'COMPONENTS.RATING_MODAL.IOS_STORE'
                        ) | translate)
                }}
            </h3>
            <h3>
                {{ 'COMPONENTS.RATING_MODAL.CALL_TO_ACTION' | translate }}
            </h3>
        </div>
        <div class="button-container">
            <ion-button class="primary-button" (click)="rate()">
                {{ 'COMPONENTS.RATING_MODAL.BUTTON_RATE' | translate }}
            </ion-button>
            <ion-button class="secondary-button" (click)="close()">
                {{ 'COMPONENTS.RATING_MODAL.BUTTON_DISMISS' | translate }}
            </ion-button>
        </div>
    </div>
</ion-content>
